<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <router-link :to="{name: eventDetails.routes.add}">
                    <el-button type="primary" class="fluid">{{ $t('add') }} Wydarzenie <i class="el-icon-plus"></i>
                    </el-button>
                </router-link>
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="80"/>
                    <el-table-column prop="name_pl" label="nazwa (pl)"/>
                    <el-table-column prop="name_en" label="nazwa (en)"/>
                    <el-table-column prop="hide" label="ukryte">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.hide"></i>
                            <i class="el-icon-close" v-else></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="akcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <router-link :to="{name: eventDetails.routes.edit, params: {id: scope.row.id}}">
                                <el-button size="small" :title="$t('edit')">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="list__pagination">
                    <el-pagination layout="prev, pager, next"
                                   @current-change="handlePageChange"
                                   :page-size="pageSize" :total="count">
                    </el-pagination>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import ListFilterComponent from '@/components/ListFilterComponent'

    export default {
        data () {
            return {
                filters: {
                    available: [
                        {
                            name: this.$i18n.t('status'),
                            query_param: 'hide',
                            options: [
                                {
                                    label: this.$i18n.t('all'),
                                    value: '',
                                    icon: 'el-icon-star-on',
                                    defaultSelected: true
                                },
                                {
                                    label: this.$i18n.t('published'),
                                    value: 'false',
                                    icon: 'el-icon-star-on'
                                },
                                {
                                    label: this.$i18n.t('unpublished'),
                                    value: 'true',
                                    icon: 'el-icon-star-off'
                                }
                            ]
                        },
                        {
                            name: this.$i18n.t('year'),
                            query_param: 'edition',
                            options: []
                        }
                    ],
                    selected: {}
                },
                data: [],
                count: 0,
                page: 1,
                pageSize: 100,
                listLoading: false,
                service: null
            }
        },
        methods: {
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            addTagsFilter () {
                this.service.tags().then(response => {
                    const listToObj = item => {
                        return {label: item.name, value: item.name}
                    }
                    const options = [
                        {label: 'Wszystkie', value: ''},
                        ...response.data.map(listToObj)
                    ]
                    this.filters.available.push({
                        name: 'Tag',
                        query_param: 'tags__name',
                        options: options
                    })
                    this.setFilter({query_param: 'tag', value: ''})
                })
            },
            addEventTypeFilter () {
                this.service.eventTypes().then(response => {
                    const listToObj = type => {
                        return {label: type, value: type}
                    }
                    const options = [
                        {label: 'Wszystkie', value: ''},
                        ...response.data.map(listToObj)
                    ]
                    this.filters.available.push({
                        name: 'Typ wydarzenia',
                        query_param: 'event_type',
                        options: options
                    })
                    this.setFilter({query_param: 'event_type', value: ''})
                })
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.data = response.data.results;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        beforeMount () {
            this.service = this.eventDetails.service;
            this.addTagsFilter()
            if (this.$route.meta.eventType === 'others') {
                this.addEventTypeFilter()
            }
        },
        mounted () {
            this.fetchData();
            // this.$store.dispatch('fetchStages')
            this.$store.dispatch('fetchEditions')
        },
        watch: {
            '$store.state.editions' (value) {
                let options = value.map(edition => {
                    return {label: edition.year, value: edition.id, defaultSelected: edition.current}
                })
                options = [
                    {label: 'Wszystkie', value: ''},
                    ...options
                ]
                const defaultFilter = options.find(option => option.defaultSelected)
                this.setFilter({
                    query_param: 'edition',
                    value: defaultFilter.value
                })
                this.$set(this.filters.available[1], 'options', options)
            }
            // '$store.state.stages' (value) {
            //     let options = value.map(stage => {
            //         return {label: stage.name_pl, value: stage.id}
            //     })
            //     options = [
            //         {label: 'Wszystkie', value: ''},
            //         ...options
            //     ]
            //     this.setFilter({
            //         query_param: 'stage',
            //         value: ''
            //     })
            //     this.$set(this.filters.available[2], 'options', options)
            // }
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// EventsList.vue?0965857c